// Test utility to check Google Sheets accessibility
export const testGoogleSheet = async () => {
  const sheetId = '1rCY-qVrj1K4_x6NfOcv0W1uiPrw_Nw0pRwHzz779RBQ';
  const testUrl = `https://docs.google.com/spreadsheets/d/${sheetId}/export?format=csv&gid=0`;
  
  console.log('🧪 Testing Google Sheet accessibility...');
  console.log('📡 Test URL:', testUrl);
  
  try {
    const response = await fetch(testUrl);
    console.log('📊 Response status:', response.status, response.statusText);
    console.log('📊 Response headers:', [...response.headers.entries()]);
    
    if (!response.ok) {
      console.error('❌ Sheet is not accessible. Status:', response.status);
      console.log('💡 Make sure your sheet is public (Share → Anyone with link → Viewer)');
      return false;
    }
    
    const csvText = await response.text();
    console.log('✅ Sheet is accessible!');
    console.log('📄 CSV content preview:', csvText.substring(0, 500) + '...');
    
    return true;
  } catch (error) {
    console.error('❌ Error accessing sheet:', error);
    return false;
  }
};

// Run test immediately when imported
testGoogleSheet();
